import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading } from '../../../../../components';
import { InfoCircleOutlined, DatabaseOutlined } from '@ant-design/icons';
import { Col, Form, Row, Input, Button, Select, PageHeader, message, Card, Breadcrumb } from 'antd';
import { masterEducationLevel, unmountMasterEducationLevel } from '../../../../../redux/actions/master/educationLevel/educationLevelAction';
import { detailFieldOfStudy, editFieldOfStudy, unmountDetailFieldOfStudy } from '../../../../../redux/actions/master/fieldOfStudy/fieldOfStudyAction';

class EditMasterFieldOfStudy extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      submitLoading: false,
    }
  }

  componentDidMount() {
    const { actionGetEducationLevel, actionGetDetail, match: { params } } = this.props;
    actionGetDetail(params.id)
    actionGetEducationLevel()
  }

  onFinish = (values) => {
    const { actionUpdate, history, getData: { data } } = this.props;
    values.id = data.id
    this.setState({ submitLoading: true })
    return actionUpdate(values, () => {
      this.setState({ submitLoading: false }, () => {
        message.success('Data updated successfully')
        history.push('/master/fields-of-study')
      })
    }, (err) => {
      this.setState({ submitLoading: false }, () => message.error(err))
    })
  }

  render() {
    const { submitLoading } = this.state;
    const { getEducationLevel, getData: { data, loading } } = this.props;

    if(getEducationLevel.loading || loading){
      return <Loading />
    }

    return (
      <React.Fragment>
        <Form onFinish={this.onFinish} layout="vertical">
          <Row style={{ position: 'sticky', zIndex: 1, width: '100%', top: 62, right: 0, marginTop: -20, marginBottom: 8, paddingBottom: 12, paddingTop: 16, backgroundColor: '#f2f2f2' }}>
            {/* Breadcrumb */}
            <Col span={24}>
              <Breadcrumb>
                <Breadcrumb.Item><DatabaseOutlined /> Master Data</Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link className="link" to="/master/fields-of-study">
                    Master Data List Fields Of Study
                  </Link> 
                </Breadcrumb.Item>
                <Breadcrumb.Item>Fields of Study</Breadcrumb.Item>
                <Breadcrumb.Item>{data.name}</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            { /* Page Header */}
            <Col span={24}>
              <PageHeader 
                className="site-page-header" 
                title="Update Field of Study Data"
                extra={[
                  <Button key="2" className="btn-save-primary" type="default" onClick={() => window.history.back()}>Cancel</Button>,
                  <Button key="1" className="btn-save-primary" type="primary" htmlType="submit" loading={submitLoading}>Update</Button>
                ]}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            { /* Form */}
            <Col span={24}>
              <Card>
                <Row gutter={16}>

                  <Col span={12}>
                    <Form.Item 
                      label="Education Level" 
                      name="educationLevelId" 
                      initialValue={data.educationLevelId}
                      rules={[
                        { required: true, message: 'This is a required field' },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {
                          getEducationLevel?.data?.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Field of Study Name" 
                      name="name" 
                      validateFirst
                      initialValue={data.name}
                      rules={[
                        { required: true, message: 'This is a required field' },
                        { min: 3, message: 'Name must be at least 3 characters long' },
                        // { max: 50, message: '50 characters only' },
                        // { pattern: new RegExp("^[a-zA-Z/ ]+$"), message: 'Only symbol ” / “ is allowed' },
                        // { pattern: new RegExp(/^([^0-9]*)$/), message: 'Number and special character are not allowed' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Status" 
                      name="enabled" 
                      initialValue={true}
                      tooltip={{ 
                        title: 'Inactive means this field of study isn’t used in master data', 
                        icon: <InfoCircleOutlined style={{ color: '#2586eb' }} />
                      }}
                      rules={[
                        { required: true, message: 'This is a required field' },
                      ]}
                    >
                      <Select>
                        <Select.Option value={true}>Active</Select.Option>
                        <Select.Option value={false}>Inactive</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Description" 
                      name="description" 
                      initialValue={data.description ? data.description : ''}
                      rules={[
                        { max: 50, message: '50 characters only' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    )
  }
  componentWillUnmount() {
    const { unmountGetEducationLevel, unmountGetDetail  } = this.props;
    unmountGetDetail()
    unmountGetEducationLevel()
  }
}

const mapStateToProps = (state) => ({
  getData           : state.fieldOfStudy.detail,
  getEducationLevel : state.educationLevel.master
})

const mapDispatchToProps = {
  actionUpdate              : editFieldOfStudy,
  actionGetDetail           : detailFieldOfStudy,
  actionGetEducationLevel   : masterEducationLevel,
  unmountGetDetail          : unmountDetailFieldOfStudy,
  unmountGetEducationLevel  : unmountMasterEducationLevel
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMasterFieldOfStudy)
